import React, { Fragment, useState } from "react";
import style from "../../../scss/TablaDatos.module.scss";
import { eliminarElector, editarCompromisoCumplido } from "../../../Api/ApiMetodo";
import Swal from "sweetalert2";
import ModalComponent from "./ModalComponent";
import { CompromisoEstadoComponent, CompromisoTextoComponent } from "./CompromisoComponent";
import { ESTADOS_COMPROMISO, estadoCompromiso } from "../../../constants/compromiso";
import AlertComponent from "../../../components/AlertComponent";
import { AccionesTabla, BotonEditar, BotonEliminar } from "../../../components/BotonIconoComponent";
import { obtenerMensajeError } from "../../../utils/mensajeError";
import { esAdmin } from "../../../utils/sesion";

const SIN_DATO = "—";

const TablaComponent = (props) => {
  const [id, setId] = useState("");
  const [cedula, setCedula] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [selectedOptionlugar, setSelectedOptionlugar] = useState(null);
  const [selectedOptionmesa, setSelectedOptionmesa] = useState(null);
  const [lider, setLider] = useState(null);

  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [compromiso, setCompromiso] = useState("");
  const [compromisoFecha, setCompromisoFecha] = useState("");
  const [grupo, setGrupo] = useState(false);
  const [mostraralert, setMostraralert] = useState(false);
  const [colorAlert, setcolorAlert] = useState("");
  const [alerta, setAlerta] = useState("");
  const [show, setShow] = useState(false);
  // inicio: posición del primer elector de la página (para numerar las filas)
  const { datos, elector, onCambio, inicio = 0 } = props;
  // el digitador solo consulta: editar, eliminar y cambiar el compromiso es del admin
  // (la interfaz solo oculta las acciones; el backend lo valida con soloAdmin)
  const puedeModificar = esAdmin();

  // elector=[] (o sin elector): se muestra la lista; un objeto: solo ese elector
  const filas = !elector || Array.isArray(elector) ? datos : [elector];

  const handleShow = (editarE) => {
    setId(editarE.id);
    setCedula(editarE.cedula);
    setNombre(editarE.nombres);
    setApellido(editarE.apellidos);
    // SelectComponent entrega solo el value, así que se guarda el texto (no el objeto { value, label })
    setSelectedOptionlugar(editarE.lugar);
    setSelectedOptionmesa(editarE.mesa);
    setLider(editarE.lider);
    setDireccion(editarE.direccion);
    setTelefono(editarE.telefono);
    setCompromiso(editarE.compromiso ?? "");
    setCompromisoFecha(editarE.compromisoFecha ?? "");
  };

  const guardarEstadoCompromiso = (item, cumplido) =>
    editarCompromisoCumplido(item.id, cumplido)
      .then((response) => {
        Swal.fire({ icon: "success", text: response.msg, timer: 1500, showConfirmButton: false });
        // refresca la tabla y el resumen de compromisos
        onCambio?.();
      })
      .catch((error) => Swal.fire({ icon: "error", text: obtenerMensajeError(error) }));

  // clic en el icono de estado: confirma y cambia el estado
  const cambiarEstadoCompromiso = (item, cumplido) => {
    Swal.fire({
      title: cumplido ? "¿Marcar el compromiso como cumplido?" : "¿Marcar el compromiso como por cumplir?",
      text: `${item.nombres} ${item.apellidos}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) guardarEstadoCompromiso(item, cumplido);
    });
  };

  // clic en el texto del compromiso: lo muestra completo y permite cambiar el estado
  const verDetalleCompromiso = (item) => {
    const cumplido = estadoCompromiso(item) === ESTADOS_COMPROMISO.CUMPLIDO;
    Swal.fire({
      title: `${item.nombres} ${item.apellidos}`,
      text: item.compromiso,
      footer: `Estado: ${cumplido ? ESTADOS_COMPROMISO.CUMPLIDO.etiqueta : ESTADOS_COMPROMISO.PENDIENTE.etiqueta}`,
      // sin permiso solo se muestra el texto completo
      showConfirmButton: puedeModificar,
      showCancelButton: true,
      confirmButtonText: cumplido ? "Marcar como por cumplir" : "Marcar como cumplido",
      cancelButtonText: "Cerrar",
    }).then((result) => {
      if (result.isConfirmed) guardarEstadoCompromiso(item, !cumplido);
    });
  };

  const eliminarCedula = (cedula) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar esta cc: ." + cedula,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Si el usuario confirma la eliminación, realiza la lógica de eliminación aquí
        eliminarElector(cedula)
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Elemento eliminado",
              text: response.msg,
            });
            // refresca la tabla sin recargar la página
            onCambio?.();
          })

          .catch((error) => console.error(error));
      }
    });
  };

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          mensaje={alerta}
          mostraralert={mostraralert}
          styleGrup={`${colorAlert} text-center  w-50`}
        />
      </div>

      {/* en celular cada fila se muestra como tarjeta (data-label da el título de cada dato) */}
      <div className={`${style.contenedor} ${style.contenedorLibre}`}>
        <table className={style.tabla}>
          <thead>
            <tr>
              <th scope="col" className={style.numero}>#</th>
              <th scope="col">Nombre</th>
              <th scope="col">Cédula</th>
              <th scope="col">Lugar</th>
              <th scope="col" className={style.centro}>Mesa</th>
              <th scope="col">Dirección</th>
              <th scope="col">Teléfono</th>
              <th scope="col">Líder</th>
              <th scope="col">Compromiso</th>
              <th scope="col" className={style.centro}>Estado</th>
              {puedeModificar && (
                <th scope="col" className={style.derecha}>
                  <span className="visually-hidden">Acciones</span>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {filas.map((item, index) => {
              const nombreCompleto = `${item.nombres} ${item.apellidos}`;
              return (
                <tr key={item.id}>
                  <td className={style.numero} data-label="#">
                    {inicio + index + 1}
                  </td>
                  <th scope="row" className={`${style.candidato} ${style.textoLargo} ${style.ancho}`} data-label="Nombre">
                    {nombreCompleto}
                  </th>
                  <td data-label="Cédula">{item.cedula}</td>
                  <td data-label="Lugar">{item.lugar || <span className={style.textoSuave}>{SIN_DATO}</span>}</td>
                  <td className={style.centro} data-label="Mesa">
                    {item.mesa ? <span className={style.chip}>{item.mesa}</span> : <span className={style.textoSuave}>{SIN_DATO}</span>}
                  </td>
                  <td className={style.textoLargo} data-label="Dirección">
                    {item.direccion || <span className={style.textoSuave}>{SIN_DATO}</span>}
                  </td>
                  <td data-label="Teléfono">{item.telefono || <span className={style.textoSuave}>{SIN_DATO}</span>}</td>
                  <td data-label="Líder">{item.lider || <span className={style.textoSuave}>{SIN_DATO}</span>}</td>
                  <td data-label="Compromiso">
                    <CompromisoTextoComponent elector={item} onVerDetalle={verDetalleCompromiso} />
                  </td>
                  <td className={style.centro} data-label="Estado">
                    <CompromisoEstadoComponent
                      elector={item}
                      onCambiarEstado={puedeModificar ? cambiarEstadoCompromiso : undefined}
                    />
                  </td>
                  {puedeModificar && (
                    <td className={`${style.derecha} ${style.acciones}`}>
                      <AccionesTabla>
                        <BotonEditar
                          etiqueta={`Editar a ${nombreCompleto}`}
                          onClick={() => {
                            handleShow(item);
                            setShow(true);
                          }}
                        />
                        <BotonEliminar
                          etiqueta={`Eliminar a ${nombreCompleto}`}
                          onClick={() => eliminarCedula(item.cedula)}
                        />
                      </AccionesTabla>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ModalComponent
        id={id}
        setId={setId}
        setShow={setShow}
        show={show}
        setCedula={setCedula}
        setNombre={setNombre}
        setApellido={setApellido}
        setSelectedOptionlugar={setSelectedOptionlugar}
        setSelectedOptionmesa={setSelectedOptionmesa}
        setLider={setLider}
        setDireccion={setDireccion}
        setTelefono={setTelefono}
        setCompromiso={setCompromiso}
        setCompromisoFecha={setCompromisoFecha}
        setGrupo={setGrupo}
        cedula={cedula}
        nombre={nombre}
        apellido={apellido}
        selectedOptionlugar={selectedOptionlugar}
        selectedOptionmesa={selectedOptionmesa}
        lider={lider}
        direccion={direccion}
        telefono={telefono}
        compromiso={compromiso}
        compromisoFecha={compromisoFecha}
        grupo={grupo}
        setcolorAlert={setcolorAlert}
        setAlerta={setAlerta}
        setMostraralert={setMostraralert}
        onCambio={onCambio}
      />
    </Fragment>
  );
};
export default TablaComponent;
